export default __webpack_public_path__ + "static/media/logo-gplay-light.23be5372.svg";